var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "mail_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 20V4h20v16zm10-7L4 8v10h16V8zm0-2 8-5H4zM4 8V6zv10z"
  })));
};
export { SvgMail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMiAyMFY0SDIyVjIwSDJaTTEyIDEzTDQgOFYxOEgyMFY4TDEyIDEzWk0xMiAxMUwyMCA2SDRMMTIgMTFaTTQgOFY2VjhWMThWOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";